import { Card, CardContent, Typography, Grid, Box } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import moment from 'moment';

const ComparisionFileDetailComponent = ({ classes, file }) => {
  const maxMetalLossLog =
    file?.corrosionLogFileData.length > 0
      ? file?.corrosionLogFileData.reduce((maxVal, log) =>
          log.totalMetalLoss > maxVal.totalMetalLoss ? log : maxVal,
        )
      : { totalMetalLoss: 0 };
  return (
    <>
      <Card className={classes.cardContainer}>
        <CardContent>
          <Typography variant="h6" gutterBottom className={classes.detailCard}>
            {file?.fileName}
          </Typography>

          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} md={4}>
              <Box className={classes.detailCard}>
                <Typography variant="subtitle2" gutterBottom>
                  Log Date
                </Typography>
                <Typography>
                  {moment(file?.logDate).format('DD. MM. YYYY')}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box className={classes.detailCard}>
                <Typography variant="subtitle2" gutterBottom>
                  Max Metal Loss
                </Typography>
                <Typography>{`${maxMetalLossLog.totalMetalLoss}%`}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box className={classes.detailCard}>
                <Typography variant="subtitle2" gutterBottom>
                  Tool
                </Typography>
                <Typography>{file?.toolUsed?.name}</Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

const styles = (theme) => ({
  cardContainer: {
    marginBottom: theme.spacing(1),
  },
  detailCard: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
});

export default withStyles(styles)(ComparisionFileDetailComponent);
